export default `
    <div class="col-xs-12 no-pad collapsable #=data.bsc||""#" id="#= data.id #">
        <div id="#= data.id #_Body" class="col-xs-12 collapsable-body #: data.containerClasses || "" #" >
            #= data.components #
        </div>
        <div id="#= data.id #_Button" class="#= data.buttonContainer || "collapse-button-container" # #: data.classes || "" #" # if (data.style) { # style="#= data.style #" # } #>
            <span class=" #= data.icon || "collapse-icon"#">
            </span>
                <a class="bind-label #= data.text || "link collapse-text" #" data-bind="text: #= data.header #" data-label-for-id="#= data.id #"></a>
        </div>
    </div>
`;
